import { SystemSettingApi } from '@/apis';
import BaseStore from './BaseStore';
import RootStore from '.';
import { flow, makeObservable, observable } from 'mobx';
import { MileageLimitSetting, OtherSettingItem, SystemSetting } from '@/types/system-setting';
import { ResponseData } from '@/types/http';
import { GetOtherSettingResponse } from '@/types/http-payload/setting';

export default class SystemSettingStore extends BaseStore {
    api: SystemSettingApi;
    systemSetting: SystemSetting | null = null;

    mileageLimitCMS: MileageLimitSetting | null = null;
    droppOffCMS: OtherSettingItem[] = [];

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            systemSetting: observable,
            mileageLimitCMS: observable,
            droppOffCMS: observable,
            getSystemSetting: flow.bound,
            updateSystemSetting: flow.bound,
            getMileageLimitAndDropOffSetting: flow.bound,
            updateMileageLimitAndDropOffSetting: flow.bound
        });
        this.api = new SystemSettingApi();
    }

    *getSystemSetting() {
        try {
            const res: ResponseData<SystemSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getSystemSetting);
            if (res.ok) {
                this.systemSetting = res.data;
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *updateSystemSetting(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.updateSystemSetting, payload);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getMileageLimitAndDropOffSetting(payload?: any) {
        try {
            const res: ResponseData<GetOtherSettingResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getMileageLimitAndDropOffSetting, payload);
            if (res.ok) {
                this.mileageLimitCMS = res?.data?.mileageLimit || {};
                this.droppOffCMS = res?.data?.dropOff || {};
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }

    *updateMileageLimitAndDropOffSetting(payload: any) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.updateMileageLimitAndDropOffSetting, payload);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    clean(): void {
        super.clean();

        this.systemSetting = null;
    }
};
